import { Navigate, useParams } from "react-router-dom";
import { useGetAddresses } from "../../api/query_hooks";
import { useGetUser } from "../../api/query_hooks";
import AccountDashboard from "./AccountDashboard";
import AccountSecurity from "./AccountSecurity";
import AccountSidebar from "./AccountSidebar";
import AccountDetails from "./AccountDetails";
import { Spinner } from "react-bootstrap";

const options = ["dashboard", "details", "security"];

const Account = () => {
    const { tab } = useParams();
    
    const userQuery = useGetUser();
    const addressQuery = useGetAddresses();


    return (!tab || !options.includes(tab)) ? <Navigate to={'/account/dashboard'} /> :
    <>
        {(userQuery.isLoading || addressQuery.isLoading) &&
            <div className="bg-black d-flex justify-content-center align-items-center container">
                <Spinner animation="border" role="status" aria-describedby="loading" />
            </div>
        }

        {(userQuery.isError || addressQuery.isError) && <></>}

        {(userQuery.isSuccess && addressQuery.isSuccess) &&
            <div id="account-page" className="bg-black d-flex">
                <AccountSidebar tab={tab} />
                {(tab === "dashboard") && <AccountDashboard user={userQuery.data?.data} />}
                {(tab === "details") && <AccountDetails user={userQuery.data?.data} addresses={addressQuery.data?.data} />}
                {(tab === "security") && <AccountSecurity user={userQuery.data?.data} />}
            </div>
        }
    </>
}

export default Account;